import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const JobWiseReportModule = new Module({
  id: 'JOB_WISE_REPORT:VIEW:*',
  name: 'Job-Wise Report',
  label: 'Job-Wise Report',
  path: 'job-wise',
  Component: ComponentLoader(
    lazy(() => import('src/content/reports/SessionReport/JobWiseReport'))
  ),
  actions: {
    exportData: {
      id: 'JOB_WISE_REPORT:ACTION:EXPORT_DATA',
      name: 'export-data',
      label: 'Export Data'
    }
  }
});

const JobWiseReportModules = [JobWiseReportModule];

export default new ModuleBundle('JobWiseReport', JobWiseReportModules);
